import {
  formatTzDate,
  parseLocalDatetimeStringToZonedDate,
} from 'Data/format.js'
import { addMinutes } from 'date-fns'

export function getBookingTime(booking, timeZoneId) {
  let startTime = parseLocalDatetimeStringToZonedDate(
    `${booking.local_start_date}T${booking.local_start_time}`,
    timeZoneId
  )
  let endTime = addMinutes(startTime, booking.duration)
  return `${formatTzDate(
    startTime,
    'MMM dd, hh:mm',
    timeZoneId
  )} - ${formatTzDate(endTime, 'hh:mmaaa', timeZoneId)}`
}
